export function pearsonWritingMaxWords(question, { bmatSitting } = {}) {
  const n = Number(question?.essay_max_words);
  if (Number.isFinite(n) && n > 0) return n;
  return bmatSitting ? 550 : 750;
}
